import {
  Modal,
  Button as ModalButton,
  Group,
  Image as MantineImage,
  Text,
} from '@mantine/core';
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import { useContext } from 'react';

import ScreenWidthContext from '@/contexts/ScreenWidthContext';
import { useUserAgent } from '@/contexts/UserAgentContext';
import { avenirFont } from '@/utils/font';
import { getProductPrices } from '@/utils/getPrice';
import imagePlaceholder from 'public/images/product-placeholder.webp';

import { Props } from './types';

const ModalPopup = ({
  quantity,
  title,
  product,
  thumbnail,
  opened,
  close,
}: Props) => {
  const { isMobile } = useContext(ScreenWidthContext);
  const { isMacOS, isAndroid } = useUserAgent();
  const router = useRouter();

  const handleRedirectToCart = () => {
    router.replace(`/koszyk`);
  };

  const modalClass = cn(avenirFont.className, 'addToCartModal');
  const { originalPrice, salePrice } = getProductPrices(product);

  return (
    <Modal.Root
      className={modalClass}
      opened={opened}
      onClose={close}
      size={isMobile ? '100%' : '50%'}
      centered
    >
      <Modal.Overlay className="container" />
      <Modal.Content className="modalWrapper">
        <Modal.Header className="modalHeader">
          <Modal.Title className="modalTitle">
            Produkt dodany do koszyka
          </Modal.Title>
          <Modal.CloseButton size="2rem" className="upperCloseButton" />
        </Modal.Header>
        <Modal.Body className="modalBody">
          <Group className="contentWrapper">
            <MantineImage
              width={120}
              height={120}
              src={thumbnail ? thumbnail : imagePlaceholder.src}
              alt="Zdjęcie produktu"
              style={{
                objectFit: 'cover',
              }}
            />
            <Group className="metaInfo">
              <Text
                className={cn('productName', {
                  ['avenirFont']: isMacOS || isAndroid,
                })}
              >
                {title}
              </Text>
              {salePrice ? (
                <Text
                  className={cn('productPrice', {
                    ['avenirFont']: isMacOS || isAndroid,
                  })}
                >
                  {quantity} x {salePrice}
                </Text>
              ) : (
                <Text
                  className={cn('productPrice', {
                    ['avenirFont']: isMacOS || isAndroid,
                  })}
                >
                  {quantity} x {originalPrice}
                </Text>
              )}
            </Group>
          </Group>
        </Modal.Body>
        <Group className="modalFooter">
          <ModalButton
            className={cn('lowerCloseButton', {
              ['avenirFont']: isMacOS || isAndroid,
            })}
            onClick={close}
          >
            Przeglądam dalej
          </ModalButton>
          <ModalButton
            className={cn('cartButton', {
              ['avenirFont']: isMacOS || isAndroid,
            })}
            onClick={handleRedirectToCart}
          >
            Idź do koszyka
          </ModalButton>
        </Group>
      </Modal.Content>
    </Modal.Root>
  );
};

export default ModalPopup;
